import React from 'react';
import { connect } from 'react-redux';

import { SentinelUser } from '@modules/auth/components/types/user';
import { CustomerAccountInfo } from '@modules/auth/components/types/customer-account';
import AccountRefresher from '@modules/auth/widgets/AccountRefresher';
import DashboardCard from '@modules/common/components/DashboardCard';
import { styled } from '@modules/common/components/ThemeProvider/utils';

import { SpacedBetween } from '../../../components/common/SpacedStyle';
import { StoreState } from '../../../meta/types/store';
import WidgetHeader from '../WidgetHeader';
import { AccountStatusInfo } from './statusInfo';

type PropsFromState = {
  user: SentinelUser;
  shAccount: CustomerAccountInfo | undefined;
};

const AccountInfoContainer = ({ shAccount, user }: PropsFromState) => {
  return (
    <AccountInfoStyle className="account-info">
      <AccountRefresher />
      <SpacedBetween>
        <WidgetHeader>Account info</WidgetHeader>
      </SpacedBetween>
      <StyledAccountType>{shAccount?.type.name} Account</StyledAccountType>
      <AccountStatusInfo shAccount={shAccount} user={user} />
    </AccountInfoStyle>
  );
};

function mapStateToProps(state: StoreState): PropsFromState {
  return {
    user: state.auth.configurableUser!,
    shAccount: state.account.account,
  };
}

const enhance = connect(mapStateToProps);

export default enhance(AccountInfoContainer);

export const AccountInfoStyle = styled(DashboardCard)`
  height: 100%;

  p {
    color: ${props => props.theme.secondaryTextColor};
  }
`;

const StyledAccountType = styled('h3')`
  text-align: center;
`;
